import { Component } from '@angular/core';
import { Filter, FilterType } from 'src/app/modules/filtering/models';
import { UsersComponent } from '../users/users.component';
import { Sort } from '@angular/material/sort';

@Component({
  standalone: false,
  selector: 'sa-banned-users',
  templateUrl: '../users/users.component.html',
  styleUrls: ['../users/users.component.scss']
})
export class BannedUsersComponent extends UsersComponent {

  // Override the stable references; parent getDisplayedColumns()/getSort() return these,
  // and are read after field init (seeds happen in ngAfterViewInit), so overrides apply.
  override readonly displayedColumns: string[] = ['profile_image', 'actions', 'user_id', 'name', 'email', 'birth', 'gender', 'media', 'country', 'login_method', 'report_count', 'like_dislike_ratio', 'given_like_dislike_ratio', 'createdAt', 'last_activity', 'bannedAt', 'active', 'subscription_tier'];
  override readonly initialSort: Sort = { active: 'bannedAt', direction: 'desc' };

  getFilter(): Filter[] {
    return [{
      type: FilterType.BANNED,
      value: true,
      mutable: false
    }];
  }
}
